import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { PaginationPageEvent, Res } from 'src/app/models';
import { LanguageService, FilesService, NotificationService, ApiKaspiPricesService, DialogModalService } from 'src/app/services';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FileUploadProcessComponent } from 'src/app/components/dialog';
import { ConfirmActionComponent } from 'src/app/components/dialog/confirm/confirm-action/confirm-action.component';

@Component({
  selector: 'app-kaspi-price-list',
  templateUrl: './kaspi-price-list.component.html',
  styleUrls: ['./kaspi-price-list.component.css']
})
export class KaspiPriceListComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  loading: boolean;
  prices: any[] = [];
  paginationInput: any;
  paginationOutput: PaginationPageEvent;
  listParams: any;
  multiple:boolean = true;

  constructor(
    public ngProgress: NgProgress,
    private router: Router,
    private languageService: LanguageService,
    private notification: NotificationService,
    private apiKaspiPrices: ApiKaspiPricesService,
    private dialogModal: DialogModalService,
    private apiFileService: FilesService,
    private NgbModal: NgbModal
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.getList();

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );
  }

  /**
   * 
   */
  getList(): void {

    this.progressRef.start();
    this.loading = true;
    this.prices = [];

    this.setListParams();

    this.apiKaspiPrices.getList(this.listParams).subscribe((response: Res) => { console.log('[RESPONSE] getPrices: ', response);

      if (response) {

        if (response.result != null) {

          this.prices = response.result.list;

          //rework date for display
          let splitDateAndTime: string = '';

          for (let i = 0; i < this.prices.length; i++) {
            splitDateAndTime = this.prices[i].date.split(' ');
            this.prices[i].date = splitDateAndTime[0].split('-').reverse().join('.') + " " + splitDateAndTime[1];
          }

          this.paginationInput = {
            count:         response.result.count,
            numberOfPages: response.result.numberOfPages,
            currentPage:   this.listParams.pageNumber,
            size:          this.listParams.countOnPage
          }
        }
      }

      this.progressRef.complete();
      this.loading = false;
    },
    error => {
      this.progressRef.complete();
      this.loading = false;
    });
  }

  /**
   * 
   */
  setListParams(): void {

    this.listParams = {
      filter: {
        org_id: null
      },
      pageNumber: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 1 : this.paginationOutput.pageNumber,
      countOnPage: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 10 : this.paginationOutput.pageSize
    }
  }


  /**
   * 
   * @param event PaginationPageEvent
   */
  pageEvent(event: PaginationPageEvent): void {

    this.paginationOutput = event;
    this.getList();
  }


  /**
  * 
  * @param ids 
  */
    onConfirm(ids: number[]) {

      let message = 'Вы действительно хотите удалить?';
  
      this.dialogModal.open(message, ConfirmActionComponent, '', 'confirmAction-window').then(
        (result) => {
  
          if (result) {
  
            this.onDelete(ids);
          }
        },
        () => { console.log('Rejected!'); }
      );
  
    }

  /**
   * 
   * @param ids 
   */
  onDelete(ids: number[]): void {

    this.progressRef.start();

    this.subscriptions.add(
      this.apiKaspiPrices.delete({ id: ids }).subscribe(response => { console.log('[RESPONSE] deletePrice: ', response);

        if (response != null) {

          this.getList();

          this.notification.show('success', 'Данные успешно удалены!');
        }

        this.progressRef.complete();
      })
    );
  }


  /**
   * 
   */
  deleteSelected(): void {

    let ids = [...new Set(this.prices.filter(val => val.checked).map( ({ id }) => id ))];
    this.onConfirm(ids);
  }


  /**
   * 
   */
  createPriceListFromPublishedProducts(): void {

    this.progressRef.start();

    this.subscriptions.add(
      this.apiKaspiPrices.createIncludingAll().subscribe(response => { console.log('[RESPONSE] createPriceListFromPublishedProducts: ', response);

        if (response != null) {

          this.router.navigate(['export', 'integrations', 'kaspi', 'edit', response.result.id]);
          this.notification.show('success', 'Данные успешно добавлены!');
        }

        this.progressRef.complete();
      })
    );
  }

 /** UPLOAD FILES VER №1 */
  /**
   *
   * @param i
   * @param j
   * @param file
   */
   onUpload(file: any = false): void {

    this.subscriptions.add(

      this.uploadFileDialogWindow(file).then(event => {

        if (event) {

          this.getList();

        }
      })
    );
  }


  /**
   *
   * @param file
   */
  uploadFileDialogWindow(file: any): any {

    let data = {
          files: file,
          option: {
            multiple: this.multiple,
            component: 'kaspi'
          }
        }

    const modalRef = this.NgbModal.open(FileUploadProcessComponent, { centered: true });

    modalRef.componentInstance.data = data;

    return modalRef.result;
  
  }


  /**
   * DOWNLOAD FILE
   * @param file
   */
  downloadFile(file: any): void {

    this.apiFileService.downloadFile(file.name, file.id);
  }


  /**
   * 
   * @param link 
   */
  copyLink(link: string) {
    
    let listener = (e: ClipboardEvent) => {
      e.clipboardData.setData('text/plain', (link));
      e.preventDefault();
    };

    document.addEventListener('copy', listener);
    document.execCommand('copy');
    document.removeEventListener('copy', listener);

    this.notification.show('success', 'Данные успешно скопированы в буфер!');
  }



  /** CHECKBOX */

  /**
   * 
   * @param index number
   * @param event 
   */
  selectedCheckBox(index: number, event: any): void {

    this.prices[index].checked = event.target.checked;
  }


  /**
   * 
   * @param event 
   */
  checkAllCheckBox(event: any): void {

    this.prices.forEach(x => x.checked = event.target.checked)
  }


  /**
   * 
   * @returns boolean
   */
  isAllCheckBoxChecked(): boolean {

    if (this.prices.length == 0) return false;

    return this.prices.every(p => p.checked);
  }


  /**
   * 
   * @returns boolean
   */
  checkedButNotAllCheckBox(): boolean {

    let pl = this.prices.length;
    let pc = this.prices.filter(val => val.checked).length;

    return (pc > 0 && pc < pl) ? true : false;
  }


  /**
   * 
   * @returns boolean
   */
  checkedCheckBox(): boolean {

    let pc = this.prices.filter(val => val.checked).length;

    return (pc > 0) ? true : false;
  }
}
